// extracted by mini-css-extract-plugin
module.exports = {"phone":"viewport_phone__dXenf","desktop":"viewport_desktop__1mZ6-"};